import { render, staticRenderFns } from "./BaseTLFilterValueItem.vue?vue&type=template&id=4a6aaecd&"
import script from "./BaseTLFilterValueItem.vue?vue&type=script&lang=ts&"
export * from "./BaseTLFilterValueItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports